export const socialLinks = [
  { label: "YouTube",         href: "https://www.youtube.com/channel/UCXFOpp-skK2-psYqVwYOj1g" },
  { label: "Pinterest",       href: "https://jp.pinterest.com/hanapinjapanese/" },
  { label: "TikTok",          href: "https://www.tiktok.com/@hanapinjapanese" },
  { label: "Instagram",       href: "https://www.instagram.com/hanapinjapanese" },
  { label: "Facebook",        href: "https://www.facebook.com/profile.php?id=61584868636111" },
  { label: "bilibili",        href: "https://space.bilibili.com/3706935259957265" },
  { label: "Apple Podcasts",  href: "https://podcasts.apple.com/jp/podcast/hanapin-emimaru-pre-n5-fun-japanese-conversations/id1896842557?l=en-US" },
  { label: "Spotify",         href: "https://open.spotify.com/show/0FeUtrzcEIW2GDg2NXofrv?si=QueySUwFTT2zY1IM3z86CQ" },
  { label: "note",            href: "https://note.com/hanapinjapanese" },
  { label: "WeChat",          href: "" }, // ← paste your WeChat public account link here
]